import { ChangeDetectionStrategy, Component, Inject, Input, LOCALE_ID, OnInit } from '@angular/core';
import { FooterComponent } from '../footer/footer.component';
import { ApplicationService } from '@klickdata/core/application';
import { AuthService } from '@klickdata/core/auth';
import { CustomerLanding } from '@klickdata/core/customer';

@Component({
    selector: 'app-guest-onboarding-footer',
    templateUrl: './guest-onboarding-footer.component.html',
    styleUrls: ['./guest-onboarding-footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GuestOnboardingFooterComponent extends FooterComponent implements OnInit {
    @Input() landing: CustomerLanding;
    public expanded: boolean;
    constructor(
        protected appService: ApplicationService,
        @Inject(LOCALE_ID) protected localeId: string,
        protected auth: AuthService
    ) {
        super(appService, localeId, auth);
    }

    ngOnInit(): void {}
}
